import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useHistory } from "react-router";
import { SESSION_TTL } from "./Utils";

function Header(props) {
  const ls = require("localstorage-ttl");
  const { isLoggedIn, setLoggedIn, setActiveUser } = props;
  const history = useHistory();

  const handleLogout = () => {
    setLoggedIn((prev) => !prev);
    setActiveUser([]);
    window.localStorage.clear();
    history.push("/");
  };

  const appVersion = process.env.REACT_APP_VERSION;
  const usuario = getCache("userData");
  const level = isLoggedIn && usuario && usuario.level ? usuario.level : 0;
  // "instructor" level = 1;
  // "examinador" level = 2;
  // "administrador" level = 3;

  function getCache(key) {
    const keyValue = ls.get(key);
    if (keyValue && keyValue != null) return JSON.parse(keyValue);
    return null;
  }

  // keep alive cache
  ls.set("jwt", ls.get("jwt"), SESSION_TTL);
  ls.set("userData", ls.get("userData"), SESSION_TTL);
  ls.set("userExams", ls.get("userExams"), SESSION_TTL);
  ls.set("dojos", ls.get("dojos"), SESSION_TTL);
  ls.set("grades", ls.get("grades"), SESSION_TTL);
  ls.set("teachers", ls.get("teachers"), SESSION_TTL);

  return (
    <Navbar expand="lg">
      <Container>
        <Navbar.Brand href="/">
          <img
            alt="faa-logo"
            src="/faa-logo-big.png"
            width="62"
            className="d-inline-block"
          />{" "}
          Carnet Digital
        </Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-end" id="basic-navbar-nav">
          <Nav>
            {level >= 3 ? (
              <NavDropdown title="ADMIN" id="basic-nav-dropdown">
                <NavDropdown.Item href="/bulkLoadUsers">
                  CARGA MASIVA ALUMNOS
                </NavDropdown.Item>
                <NavDropdown.Item href="/bulkLoadExams">
                  CARGA MASIVA EXAMENES
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="/bulkProcessUsers">
                  PROCESAR ALUMNOS
                </NavDropdown.Item>
                <NavDropdown.Item href="/bulkProcessExams">
                  PROCESAR EXAMENES
                </NavDropdown.Item>
                <NavDropdown.Item href="/bulkProcessDojos">
                  PROCESAR DOJOS
                </NavDropdown.Item>
                <NavDropdown.Item href="/updateAikikai">
                  ACTUALIZAR DANES
                </NavDropdown.Item>
                <NavDropdown.Item href="/updatePaid">
                  ACTUALIZAR PAGO EXAMENES
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="/listDojos">
                  EXPORTAR DOJOS
                </NavDropdown.Item>
                <NavDropdown.Item href="/listUsers">
                  EXPORTAR ALUMNOS
                </NavDropdown.Item>
                <NavDropdown.Item href="/listExams">
                  EXPORTAR EXAMENES
                </NavDropdown.Item>
                <NavDropdown.Item href="/listReserves">
                  EXPORTAR RESERVAS
                </NavDropdown.Item>
                <NavDropdown.Item href="/listTeachers">
                  EXPORTAR EXAMINADORES
                </NavDropdown.Item>
              </NavDropdown>
            ) : null}
            {/* <Nav.Link href="/info">INFO</Nav.Link> */}
            {level >= 1 ? (
              <>
                <Nav.Link href="/aportes">APORTES</Nav.Link>
                <NavDropdown title="EXAMINAR" id="basic-nav-dropdown">
                  <NavDropdown.Item href="/examinationList">
                    RESERVA DE TURNO PARA EXAMEN
                  </NavDropdown.Item>
                  {level >= 2 ? (
                    <NavDropdown.Item href="/qualifyList">
                      DIA DE EXAMEN
                    </NavDropdown.Item>
                  ) : null}
                  <NavDropdown.Item href="/queryQualifyList">
                    REPORTE DE FECHAS PASADAS
                  </NavDropdown.Item>
                  {level >= 2 ? (
                    <NavDropdown.Item href="/examineList">
                      INFORMAR MIS APROBADOS
                    </NavDropdown.Item>
                  ) : null}
                  <NavDropdown.Item href="/examinePrevList">
                    INFORMAR ANTERIORES A 2021
                  </NavDropdown.Item>
                  {level >= 3 ? (
                    <NavDropdown.Item href="/paymentList">
                      PAGOS
                    </NavDropdown.Item>
                  ) : null}
                  <NavDropdown.Item href="/dojosList">
                    MIS DOJOS
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/listNafudaKake">
                    NAFUDA KAKE
                  </NavDropdown.Item>
                </NavDropdown>
              </>
            ) : null}
            {isLoggedIn ? (
              <Nav.Link href="#" onClick={handleLogout}>
                SALIR
              </Nav.Link>
            ) : (
              <Nav.Link href="/signin">INGRESAR</Nav.Link>
            )}
            <Nav.Item>
              <Nav.Link
                style={{ fontSize: "10px", paddingTop: "15px" }}
                eventKey="disabled"
                disabled
              >
                v{appVersion}
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
export default Header;
